const toggleIconHiddenClass = 'tool-block-header__input-icon_hidden';
const togglePassword = document.querySelector('[data-js-toggle-password]') as HTMLElement;
const password = document.querySelector('[data-js-password]') as HTMLInputElement;
const passwordIconYes = document.querySelector('.tool-block-header__input-icon-yes') as HTMLElement;
const passwordIconNo = document.querySelector('.tool-block-header__input-icon-no') as HTMLElement;

togglePassword.addEventListener('click', () => {
    const type = password.getAttribute('type') === 'password' ? 'text' : 'password';

    password.setAttribute('type', type);

    if (type === 'text') {
        passwordIconYes.classList.add(toggleIconHiddenClass);
        passwordIconNo.classList.remove(toggleIconHiddenClass);
    } else {
        passwordIconYes.classList.remove(toggleIconHiddenClass);
        passwordIconNo.classList.add(toggleIconHiddenClass);
    }
});

export {};
